import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-quickresend',
  templateUrl: './dashboard-quickresend.component.html',
  styleUrls: ['./dashboard-quickresend.component.css']
})
export class DashboardQuickresendComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/dash-board/dashboard-quickresend/dashboard-quickresend.component.ts